import { useGetConclusionQuery } from "../conclusionsSlice";

const useConclusion = ({ id }) => {
  const conclusion = useGetConclusionQuery(
    { id },
    {
      skip: id == null,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    }
  );

  return conclusion;
};

export default useConclusion;
